export default {
    name: "SettingsUserManagementAlerts",

    emits: ["clear-error", "clear-success"],

    props: {
        load_error: {
            type: String,
            default: ""
        },
        save_success: {
            type: String,
            default: ""
        }
    },

    data() {
        return ({
            snackbar_timeout_id: null
        });
    },

    watch: {
        load_error(message) {
            if (message) {
                this.start_snackbar_timer();
            }
        },

        save_success(message) {
            if (message) {
                this.start_snackbar_timer();
            }
        }
    },

    beforeUnmount() {
        this.clear_snackbar_timer();
    },

    methods: {
        clear_snackbar_timer() {
            if (this.snackbar_timeout_id) {
                clearTimeout(this.snackbar_timeout_id);
                this.snackbar_timeout_id = null;
            }
        },

        start_snackbar_timer() {
            this.clear_snackbar_timer();
            this.snackbar_timeout_id = setTimeout(() => {
                this.$emit("clear-error");
                this.$emit("clear-success");
                this.snackbar_timeout_id = null;
            }, 5000);
        },

        clear_error() {
            this.clear_snackbar_timer();
            this.$emit("clear-error");
        },

        clear_success() {
            this.clear_snackbar_timer();
            this.$emit("clear-success");
        }
    }
};
